<template>
  <span>
    Booking
    <router-link
      tag="a"
      :to="`/bookings/overview/:date?${eventLog.bookingId}`"
      >#{{ eventLog.bookingId }}
    </router-link>
    created
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionBookingCreated',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
